define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../../store", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, store_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWpDoc = void 0;
    class FWpDoc extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WpId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WpIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WpStatus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WpStatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocDescError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsUpload", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsUploadError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWorksProject", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FWpDoc.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FWorksProject = parent;
            this.WpId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.FWorksProject = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WpId = (0, EntityUtil_1.toInt)(entity.WpId);
            a.WpStatus = (0, EntityUtil_1.toInt)(entity.WpStatus);
            a.DocType = (0, EntityUtil_1.toInt)(entity.DocType);
            a.DocName = b.DocName;
            a.DocDesc = b.DocDesc;
            a.IsUpload = (0, EntityUtil_1.toInt)(entity.IsUpload);
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditEditDate = b.AuditEditDate;
            a.AuditEditUser = b.AuditEditUser;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FWpDoc.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WpId", "Works Project Id");
                this.validateReqNumber(validationState, "WpStatus", "Works Project Status");
                this.validateReqNumber(validationState, "DocType", "Document Type");
                this.validateReqString(validationState, "DocName", "Document Name");
                this.validateReqNumber(validationState, "IsUpload", "Is Uploaded?");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WpId: this.WpId,
                WpStatus: this.WpStatus,
                DocType: this.DocType,
                DocName: this.DocName,
                DocDesc: this.DocDesc,
                IsUpload: this.IsUpload,
                AuditCreateDate: this.AuditCreateDate,
                AuditCreateUser: this.AuditCreateUser,
                AuditEditDate: this.AuditEditDate,
                AuditEditUser: this.AuditEditUser,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static openDocument(document) {
            services_1.SrmsServiceManager.Instance.Facility.getFacilityWorksProjectDocument(document.Id);
        }
        static uploadDocument(wp, documentType, fileName, base64File) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Uploading Document");
                if (wp.Facility.hasChanges()) {
                    store_1.StoreManager.Instance.modalStore.createInfoModal("You have unsaved changes. Please save your work before uploading a document", null);
                }
                else {
                    services_1.SrmsServiceManager.Instance.Facility.uploadFacilityWorksProjectDocument(wp.Id, documentType, fileName, base64File).then(d => {
                        let x = new FWpDoc(d, wp);
                        wp.FWpDoc.push(x);
                        resolve(x);
                    });
                }
            });
        }
        static createDocument(wp, documentType) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating Document");
                services_1.SrmsServiceManager.Instance.Facility.generateFacilityWorksProjectDocument(wp.toJson(), documentType).then(d => {
                    let x = new FWpDoc(d, wp);
                    wp.FWpDoc.push(x);
                    resolve(x);
                });
            });
        }
    }
    exports.FWpDoc = FWpDoc;
    Object.defineProperty(FWpDoc, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FWpDoc"
    });
    Object.defineProperty(FWpDoc, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Works Project Document"
    });
    Object.defineProperty(FWpDoc, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WpId", "WpStatus", "DocType", "DocName", "DocDesc", "IsUpload", "AuditCreateDate", "AuditCreateUser", "AuditEditDate", "AuditEditUser"]
    });
    Object.defineProperty(FWpDoc, "WpIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpDoc, "WpStatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpDoc, "WpStatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpDoc, "DocTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpDoc, "DocTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpDoc, "DocNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpDoc, "DocNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpDoc, "DocDescLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpDoc, "DocDescTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter a description for the document"
    });
    Object.defineProperty(FWpDoc, "DocDescReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpDoc, "IsUploadReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpDoc, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpDoc, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpDoc, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpDoc, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpDoc, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpDoc, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "WpId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "WpIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "WpStatus", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "WpStatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "DocType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "DocTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "DocName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "DocNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "DocDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "DocDescError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "IsUpload", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "IsUploadError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpDoc.prototype, "FWorksProject", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpDoc.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpDoc.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpDoc.prototype, "merge", null);
});
